import { ProductReviewValidationError } from '@spa/generated/graphql/graphql';
import { WriteReviewFormFields } from './bazaarvoiceWriteReviewModalTypes';

const FIELD_ALIASES: Record<string, keyof WriteReviewFormFields> = {
  rating: 'rating',
  reviewtext: 'reviewText',
  text: 'reviewText',
  title: 'reviewTitle',
  reviewtitle: 'reviewTitle',
  nickname: 'nickname',
  username: 'nickname',
  usernickname: 'nickname',
  email: 'email',
  useremail: 'email',
  emailaddress: 'email',
  isrecommended: 'recommendation',
  recommendation: 'recommendation',
  photo: 'photos',
  photos: 'photos'
};

// Bazaarvoice's account-configured extra questions aren't in FIELD_ALIASES above (their ids are
// account-specific, not a fixed set) -- route them to their dynamic Formik path instead, using
// the exact id casing the error reports back (matches how getProductReviewForm/buildExtraFieldSchema
// key the same field elsewhere in this form).
const EXTRA_FIELD_ID_PREFIX = 'contextdatavalue_';

export type WriteReviewFieldErrors = Partial<Record<keyof WriteReviewFormFields, string>> &
  Record<string, string>;

const mapProductReviewValidationErrors = (
  validationErrors: ReadonlyArray<ProductReviewValidationError>
): WriteReviewFieldErrors => {
  const fieldErrors: WriteReviewFieldErrors = {};

  validationErrors.forEach(({ field, message }) => {
    const formikField = FIELD_ALIASES[field.toLowerCase()];
    if (formikField) {
      fieldErrors[formikField] = message;
    } else if (field.toLowerCase().startsWith(EXTRA_FIELD_ID_PREFIX)) {
      fieldErrors[`extraFields.${field}`] = message;
    }
  });

  return fieldErrors;
};

export default mapProductReviewValidationErrors;
